



























import { Component, Prop, Vue } from 'vue-property-decorator';
import ui from '@/store/modules/ui';
import { redirectToLocation } from '@/commons/redirectManager';
import Logo from '@/components/UI/Logo.vue';
import CartHeader from '@/components/Commons/Header.vue';
import CartFooter from '@/components/Commons/Footer.vue';

@Component({
  components: {
    Logo,
    CartHeader,
    CartFooter,
  },
})
export default class Sidebar extends Vue {
  @Prop() public sidebarId!: string;
  @Prop() public title!: string;

  get isOpen(): boolean {
    return this.sidebarId === ui.sidebarActive;
  }

  get len(): number {
    return ui.sidebarLength;
  }

  private close() {
    ui.closeSidebar();
  }

  private back() {
    ui.popSidebar();
  }

  private closeCart() {
    redirectToLocation('/');
  }
}
